import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { mainApiUrl, baseHeaders } from '@constants'
import { prepareHeaders, transformResponse } from '@src/reduxjs'
import { base62Encode } from '@src/utils'
import ms from 'ms'

const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: fetchBaseQuery({ baseUrl: mainApiUrl, prepareHeaders }),
  endpoints: (builder) => ({
    getAlbums: builder.query({
      query: (userId) => {
        return `users/${userId}/dashboard/albums`
      },
      transformResponse,
    }),
    getPhotos: builder.query({
      query: ({ page, perPage, from, to, user, timezone }) => {
        const params = {}

        if (page) {
          params.page = page
        }

        if (perPage) {
          params.per_page = perPage
        }

        if (from) {
          params.from = from
        }

        if (to) {
          params.to = to
        }

        if (timezone) {
          params.timezone = base62Encode(timezone)
        }

        return { url: `users/${user.id}/dashboard/photos`, params }
      },
      transformResponse,
    }),
    getTimeslots: builder.query({
      query: ({ page, perPage, from, to, user }) => {
        const params = {}

        if (from) {
          params.from = from
        }

        if (to) {
          params.to = to
        }

        return { url: `users/${user.id}/dashboard/photos/timeslots`, params }
      },
      transformResponse,
    }),
  }),
})

export const { useGetPhotosQuery, useGetAlbumsQuery, useGetTimeslotsQuery } = dashboardApi

export default dashboardApi
